import React from "react";
//import { Test } from './GenreSelectionJs.styles';

const TagSelection = ({ tags, selectTag }) => {
  if (tags.length === 0) return null;
  return (
    <div className="TagsWrapper">
      {
        <div className="tag-choice-wrapper">
          {tags &&
            tags.map((tag) => (
              <span
                className="tag-choice"
                key={tag.tag_id}
                onClick={(e) => {
                  selectTag(tag);
                }}
              >
                {tag.tag}
              </span>
            ))}
        </div>
      }
    </div>
  );
};

export default TagSelection;
